<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { cn } from '@/lib/utils';

interface SheetHeaderProps {
  class?: HTMLAttributes['class'];
  padded?: boolean;
}

const props = withDefaults(defineProps<SheetHeaderProps>(), {
  padded: false,
});
</script>

<template>
  <div data-slot="sheet-header" :class="cn('flex flex-col gap-1.5 p-4', padded && 'px-10', props.class)">
    <slot />
  </div>
</template>
